import { useEffect, useRef, useState } from "react";

export const useLazyImg = (
  initialImgURL?: string,
  fallbackImgURL?: string,
  reserveImgUrl?: string
) => {
  const [imgLoading, setImgLoading] = useState(true);
  const [currentImgURL, setCurrentImgURL] = useState<string | undefined>(
    initialImgURL
  );
  const imgRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    setImgLoading(true);
    setCurrentImgURL(initialImgURL || reserveImgUrl || fallbackImgURL);
  }, [initialImgURL, reserveImgUrl, fallbackImgURL]);

  useEffect(() => {
    if (imgRef.current && imgRef.current.complete) {
      // Если изображение уже загружено, сразу вызываем handleLoad
      handleLoad();
    }
  }, [currentImgURL]);

  const handleLoad = () => {
    setImgLoading(false);
  };

  const handleError = () => {
    if (currentImgURL === initialImgURL && reserveImgUrl) {
      setCurrentImgURL(reserveImgUrl);
    } else if (currentImgURL !== fallbackImgURL) {
      setCurrentImgURL(fallbackImgURL);
    }
    setImgLoading(false);
  };

  return { imgLoading, handleLoad, handleError, currentImgURL, imgRef };
};
